import { httpRequest } from "@services/http";
import type { AdGroup } from "@models/adGroup.model";

export interface CreateAdGroupPayload {
  name: string;
  audience_definition_id?: number | null;
  /** Omitted leaves the choice alone; `networks` with follow=true is refused (MPN-1467). */
  follow_campaign_networks?: boolean;
  networks?: string[];
}

export class CommandCreateAdGroup {
  async run(launchId: number, payload: CreateAdGroupPayload): Promise<AdGroup> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/ad-groups/`;
    return httpRequest<AdGroup>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
}
